module.exports = __webpack_public_path__ + "img/logo.54b662b1.png";